import { useTranslations } from 'next-intl';
import { observer, inject } from 'mobx-react';
import CloseOneIcon from '../svg/CloseOneIcon';
import ButtonWithLoading from '../form-fields/ButtonWithLoading';

const ClearCartModal = inject('studioStore')(observer(({
  isOpen,
  onClose,
  onConfirm,
  studioStore,
}) => {
  const t = useTranslations('Cart');
  const tg = useTranslations('General');

  if (!isOpen) return null;

  const container = studioStore.settings.product_popup?.container;
  const productInfoBackgroundColor = studioStore.settings.product_popup?.product_info_background_color || 'white';
  const primaryColor = studioStore.settings.colors.primary_color;

  let classes = "fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-md md:mx-auto max-h-[90vh] z-[60] overscroll-contain";
  const style = {
    backgroundColor: productInfoBackgroundColor,
  };

  if (container === "stamp") {
    classes = classes + " stamp-border";
    style.backgroundImage = `radial-gradient(8px, transparent 98%, ${productInfoBackgroundColor}),linear-gradient(${productInfoBackgroundColor} 0px, ${productInfoBackgroundColor} 0px)`;
    style.backgroundColor = '';
  } else {
    classes = classes + " rounded-lg shadow-lg p-4 bg-white";
  }

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[60] overflow-y-auto" data-testid="clear-cart-confirm-modal">
      <div className="fixed inset-0 transition-opacity" aria-hidden="true" data-testid="modal-backdrop">
        <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>

      <div className={classes} style={style}>
        <button
          className="absolute top-4 md:-top-8 left-4 md:-left-10 rtl:right-4 rtl:md:-right-10 rtl:left-auto z-10"
          onClick={onClose}
        >
          <CloseOneIcon size="28px" stroke={primaryColor} />
        </button>

        <div className="max-h-[86vh] overflow-y-auto">
          <div className="p-3 md:p-6">
            <div className="px-4 md:px-8">
              <div className="text-center">
                <h2 className="mt-3 mb-6 text-2xl font-semibold" style={{color: primaryColor}}>
                  {t('confirm_clear_cart')}
                </h2>
                <p className="text-lg mb-8" style={{color: studioStore.settings.colors.text_secondary_color}}>
                  {t('clear_cart_confirmation_text')}
                </p>
                <div className="flex justify-center space-x-4">
                  <ButtonWithLoading
                    type="button"
                    isLoading={false}
                    text={tg('cancel')}
                    onClick={onClose}
                    outline
                    className="w-1/2"
                    data-testid="cancel-button"
                  />
                  <ButtonWithLoading
                    type="button"
                    isLoading={false}
                    text={tg('confirm')}
                    onClick={handleConfirm}
                    className="w-1/2"
                    data-testid="confirm-button"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}));

export default ClearCartModal;